export type InvoiceDocumentClass = "purchase" | "sales" | "unknown";

const normalize = (v: any) => String(v ?? "").trim().toLowerCase();

export const getInvoiceDocumentClass = (invoice: any): InvoiceDocumentClass => {
  const baseType = normalize(invoice?.baseType);
  const isIssued = normalize(invoice?.isIssued);

  // Purchase/Cost documents
  if (
    (baseType === "8" && isIssued === "0") || // received offer
    (baseType === "2" && isIssued === "1") || // purchase order
    (baseType === "1" && isIssued === "0") // received invoice
  ) {
    return "purchase";
  }

  // Sales/Revenues documents
  if (
    (baseType === "4" && isIssued === "0") || // estimate
    (baseType === "2" && isIssued === "0") || // sales order
    (baseType === "1" && isIssued === "1") // issued invoice
  ) {
    return "sales";
  }

  // Fallback by document type string
  const docType = normalize(invoice?.docType ?? invoice?.type);
  if (docType === "invoice-issued" || docType === "order-received" || docType === "offer-issued") {
    return "sales";
  }
  if (docType === "invoice-received" || docType === "order-issued" || docType === "offer-received") {
    return "purchase";
  }

  return "unknown";
};

export const isPurchaseDocument = (invoice: any): boolean =>
  getInvoiceDocumentClass(invoice) === "purchase";

export const isSalesDocument = (invoice: any): boolean =>
  getInvoiceDocumentClass(invoice) === "sales";

